


















































































































































































































































































































































import Vue from "vue";
import { storeOnlineStatus } from '../js/Store';
import { getEndPoint, UPDATE_TIME } from '../config';
import axios from 'axios';
import $ from 'jquery';

if (document.getElementById('form')) {
  storeOnlineStatus.setReception();
  // 状態を更新し続ける
  setInterval(async () => {
    if (document.visibilityState !== 'visible') return;
    await storeOnlineStatus.setReception();
  }, UPDATE_TIME);
}
export default Vue.extend({
  name: "Form",
  data() {
    return {
      sharedState: storeOnlineStatus.state,
      seen: 'pageTop', // pageTop, confirm, sending, result, error, cancelled, unavailableArea
      name_sei: '',
      name_mei: '',
      birth_y: '',
      birth_m: '',
      birth_d: '',
      gender: '',

      // 通常の都道府県
      pref_name: '',
      preflist: [
        { name: '東京都' },
        { name: '神奈川県' },
        { name: '千葉県' },
        { name: '埼玉県' },
        { name: '愛知県' },
        { name: '大阪府' },
        { name: '兵庫県' },
        { name: '京都府' },
        { name: '奈良県' },
        { name: '福岡県' },
      ],

      // クレジットカード用の都道府県
      about_pref_name: '',
      about_preflist: [
        { name: '東京都23区' },
        { name: '東京都23区以外' },
        { name: '神奈川県' },
        { name: '千葉県' },
        { name: '埼玉県' },
      ],

      city_name: '',
      citylist: '',
      symptom_list: [
        { name: '高熱' },
        { name: '咳・喉の痛み' },
        { name: '鼻水' },
        { name: '頭痛' },
        { name: '嘔吐' },
        { name: '腹痛・下痢' },
        { name: '胸痛' },
        { name: '腰痛・背部痛' },
        { name: '切り傷・刺し傷' },
        { name: '打撲・関節痛' },
        { name: '皮膚症状' },
        { name: 'その他の症状' },
      ],
      address1: '',
      address2: '',
      tel: '',
      email: null,
      payment: '',
      request_reply_method: null,
      symptom_description: [],
      symptom_detail: '',
      error: {
        name_sei: false,
        name_mei: false,
        birth_y: false,
        birth_m: false,
        birth_d: false,
        gender: false,
        about_pref_name: false,
        pref_name: false,
        city_name: false,
        address1: false,
        address2: false,
        symptom_description: false,
        tel: false,
        email: false,
      },
      // 郵便番号チェック用
      status: '',
      zip_code: '',
      addr: {
        extended: '',
        locality: '',
        region: '',
        region_id: 0,
        street: '',
      },
      page: 'area',
      is_production: false,
      is_changed: false,
      is_fetch: false,
      user_site_url: '',
      sharedState: null,

      // oncall専用
      oncall_shisetsu: '',
      oncall_ishi: '',

      endpoint: '',
    }
  },
  created: function() {
    // 以下郵便番号チェック用
    this.is_production = process.env.NODE_ENV  === 'production'
    this.endpoint = getEndPoint(process.env.NODE_ENV);
    this.sharedState = storeOnlineStatus.state;
  },
  mounted(){
    // 以下郵便番号チェック用、オンライン診療判定用
    this.page = 'contact';
  },
  computed: {
    // 以下郵便番号チェック用
    canSearch(){
      if (this.is_fetch || !this.addr.region || !this.addr.locality || !this.addr.street) {
        return false;
      }
      return true;
    },
    buttonClass(){
      if (!this.canSearch) {
        return 'buttonH--disabled'
      }
      return ''
    },
    buttonDisabled(){
      return !this.canSearch
    },
    sanitize_zip_code(){
      const zip =  this.zip_code
        .replace(/(\-|ー)/g, '')
        .replace(/[Ａ-Ｚａ-ｚ０-９]/g, s=> {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }
      )
      if (zip.length != 7) return ''
      return zip
    },
    formated_zip_code(){
      if(!this.sanitize_zip_code) return ''
      if(this.sanitize_zip_code.length < 7) return ''
      const str = this.sanitize_zip_code.replace(/[^0-9]/g, '')
      return str.substr(0, 3) + "-" + str.substr(3, 4)
    },
    closed(){
      if(!this.sharedState) return true;
      return this.sharedState.reception.closed;
    },
    ubie_inquiry_token(){
      const url = new URL(location);
      return url.searchParams.get('inquiryToken') || null;
    },
    isContactPage(){
      return this.page === 'contact'
    }
  },
  methods: {
    /**
     * TODO: not_coveredがtrueのときもリストに追加している（trueでも対象地域に入っている箇所もあるため）
     * APIから地域リスト読み込み
     */
    setCityList() {
      this.city_name = '';
      this.citylist = '';
      axios
        .get(this.endpoint.city + '?prefecture_name=' + this.pref_name)
        .then(response => {
          if (!Object.keys(response.data.cities).length) {
            this.error.pref_name = '市・区が取得できませんでした。お手数ですがお電話（050-5433-5721）にてご相談ください。';
            return;
          }
          this.error.pref_name = '';
          this.citylist = response.data.cities;
        })
        .catch((e) => {
          this.error.pref_name = '市・区が取得できませんでした。お手数ですがお電話（050-5433-5721）にてご相談ください。';
          console.log('error', e);
        });
    },
    /**
     * スクロール位置
     */
    scrollTopAnimate() {
      if ($('#formTop').length) {
        $('body,html').animate({ scrollTop: $('#formTop').offset().top }, 300, 'swing');
      } else {
        $('body,html').animate({ scrollTop: 0 }, 300, 'swing');
      }
    },
    /**
     * 1つ前の画面へ戻る
     */
    prevSeen(target) {
      this.scrollTopAnimate();
      this.seen = target;
    },
    /**
     * 1つ次の画面へ進む
     */
    nextSeen(target) {
      if  (target=== 'confirm') {
        if (this.validateForm() === false) {
          this.scrollTopAnimate();
          return;
        }
      }

      this.scrollTopAnimate();

      if (target === 'result') {
        this.seen = 'sending';
        this.sendApi();
        return;
      }

      this.seen = target;
    },
    /**
     * TODO: ロジックの最適化、共通化
     * フォームのバリデーション
     */
    validateForm() {
      // 一旦エラーをリセット
      for (var i in this.error) {
        this.error[i] = false;
      }

      this.validateFormCommon();
      this.validateFormPayment();
      this.validateFormOnline();
      this.validateFormOncall();

      // エラーがあればfalse
      for (var i in this.error) {
        if (this.error[i] !== false) {
          console.log("error: ", this.error);
          return false;
        }
      }
      return true;
    },
    /**
     * 共通のバリデーション
     */
    validateFormCommon() {
      // 未入力チェック
      if (this.name_sei === '') {
        this.error.name_sei = '氏名(姓)が未入力です。';
        if (this.page === 'oncall') {
          this.error.name_sei = '名字(かな)が未入力です。';
        }
      }
      if (this.page !== 'oncall') {
        if (this.name_mei === '') {
          this.error.name_mei = '氏名(名)が未入力です。';
        }
      }
      // カタカナ入力チェック
      if (!this.name_sei.match(/^[\u30a0-\u30ff\u3040-\u309f]*$/)) {
        this.error.name_sei = '氏名(姓)は全角カタカナかひらがなで入力してください。';
        if (this.page === 'oncall') {
          this.error.name_sei = '名字(かな)は全角カタカナかひらがなで入力してください。';
        }
      }
      if (!this.name_mei.match(/^[\u30a0-\u30ff\u3040-\u309f]*$/)) {
        this.error.name_mei = '氏名(名)は全角カタカナかひらがなで入力してください。';
        if (this.page === 'oncall') {
          this.error.name_mei = '名前(かな)は全角カタカナかひらがなで入力してください。';
        }
      }
      // 電話番号チェック
      if (!this.tel.match(/^0[5789]0\d{8}$|^0\d{9}$/)) {
        this.error.tel = '数字のみの電話番号を入力してください。';
      }
      if (this.tel === '') {
        this.error.tel = '未入力です。';
      }
    },
    /**
     * 支払い方法で異なる箇所のバリデーション
     */
    validateFormPayment() {
      if (this.page === 'oncall') {
        return;
      }

      if (this.payment === 'クレジットカード') {
        // クレジットカードのときのみ住所形式が異なる
        if (this.about_pref_name === '') {
          this.error.about_pref_name = '未入力です。';
        }
      } else {
        if (this.pref_name === '') {
          this.error.pref_name = '未入力です。';
        }
        if (this.city_name === '') {
          this.error.city_name = '未入力です。';
        }
        if (!this.isContactPage && this.address1 === '') {
          this.error.address1 = '未入力です。';
        }
        // 任意入力
        //if (this.address2 === '') {
        //  this.error.address2 = '未入力です。';
        //}
      }
    },
    /**
     * オンライン診療かどうかで異なる箇所のバリデーション
     */
    validateFormOnline() {
      if (this.page === 'oncall') {
        return;
      }

      // オンライン診療
      if (this.page === 'online') {
        if (this.payment === '') {
          this.error.payment = 'お支払い方法を選択してください。';
        }
        if (this.symptom_description.length <= 0) {
          this.error.symptom_description = '症状を選択してください。';
        }
        //if (this.request_reply_method === null) {
        //  this.error.request_reply_method = '未入力です。';
        //}
        //if (this.symptom_detail === '') {
        //  this.error.symptom_detail = '未入力です。';
        //}
      } else {
        if (!this.isContactPage) {
          if (this.symptom_description.length <= 0) {
            this.error.symptom_description = '症状は1つ以上選択してください。';
          }
          // 単純に日付の桁数と最大数値が合っているかチェック
          if (!this.birth_y.match(/^(\d{4})$/)) {
            this.error.birth_y = '半角数字で生年月日(西暦)を入力してください。';
          }
          if (!isFinite(this.birth_m) || this.birth_m > 12) {
            this.error.birth_m = '半角数字で生年月日(月)を入力してください。';
          }
          if (!isFinite(this.birth_d) || this.birth_d > 31) {
            this.error.birth_d = '半角数字で生年月日(日)を入力してください。';
          }
          if (this.birth_y === '') {
            this.error.birth_y = '生年月日(西暦)が未入力です。';
          }
          if (this.birth_m === '') {
            this.error.birth_m = '生年月日(月)が未入力です。';
          }
          if (this.birth_d === '') {
            this.error.birth_d = '生年月日(日)が未入力です。';
          }
          // 生年月日が実在するかチェック
          if (this.error.birth_y === false && this.error.birth_m === false && this.error.birth_d === false) {
            if (!this.isValidBirthDay(this.birth_y, this.birth_m, this.birth_d)) {
              this.error.birth_y = '実在する生年月日を入力してください。';
            }
          }
          // メールアドレスチェック
          if (!this.email.match(/^[a-zA-Z0-9_#!$%&'*+\-{|}~^/=?.]+@[a-zA-Z0-9][a-zA-Z0-9.-]+\.[A-Za-z]+$/)) {
            this.error.email = 'メールアドレスの形式で入力してください。';
          }
          if (this.email === '') {
            this.error.email = '未入力です。';
          }
          if (this.gender === '') {
            this.error.gender = '未入力です。';
          }
          if (this.address1 === '') {
            this.error.address1 = '未入力です。';
          }
        }
        if (this.pref_name === '') {
          this.error.pref_name = '未入力です。';
        }
        if (this.city_name === '') {
          this.error.city_name = '未入力です。';
        }
        // 任意入力
        //if (this.address2 === '') {
        //  this.error.address2 = '未入力です。';
        //}
      }
    },
    /**
     * oncall用のバリエーション
     */
    validateFormOncall() {
      if (this.page !== 'oncall') {
        return;
      }

      if (this.oncall_shisetsu === '') {
        this.error.oncall_shisetsu = '未入力です。';
      }
      if (this.oncall_ishi === '') {
        this.error.oncall_ishi = '未入力です。';
      }
      if (this.symptom_detail === '') {
        this.error.symptom_detail = '未入力です。';
      }
    },
    /**
     * 誕生日入力の妥当性チェック
     */
    isValidBirthDay(y, m, d) {
      y = Number(y);
      m = Number(m - 1);
      d = Number(d);
      var dateObj = new Date(y, m, d);
      if (isNaN(dateObj)) {
        return false;
      } else if(dateObj.getFullYear() == y && dateObj.getMonth() == m && dateObj.getDate() == d) {
        return true;
      }
      return false;
    },
    /**
     * エンドポイントのURLを環境ごとに設定
     */
    getEndPointUrl() {
      return this.endpoint.contact;
    },
    /**
     * 症状詳細をマージする
     * ※症状詳細は運用上備考のような使い方をしている
     */
    mergeSymptomDesc() {
      var symptomDesc = '';

      // オンライン診療の場合は支払い方法をマージして返す。症状は1つのみ。
      if (this.page === 'online') {
        // クレジットカードの場合は専用の都道府県もマージ
        if (this.payment === 'クレジットカード') {
          return '支払い方法：クレジットカード\r\n' + '住所：' + this.about_pref_name + '\r\n' + this.symptom_description;
        } else {
          return '支払い方法：コンビニ支払い（NP後払い）\r\n' + this.symptom_description;
        }
      }

      // 症状詳細のリストを「, 」区切りで文字列化
      for (var i = 0; i < this.symptom_description.length; i++) {
        symptomDesc += this.symptom_description[i] += ', ';
      }
      symptomDesc = symptomDesc.slice(0, -2);

      // 症状詳細があれば
      if (this.symptom_detail !== '') {
        if (symptomDesc) {
          symptomDesc += '\r\n' + this.symptom_detail;
        } else {
          symptomDesc += this.symptom_detail;
        }
      }

      if (this.ubie_inquiry_token) {
        symptomDesc += `\r\nオペレーターさんへ\r\nこちらの患者は提携サイトのubieにて問診・一次トリアージ済みです。\r\n`
          + `問診は以下のサイトから、患者IDで検索して、問診内容とトリアージの色を張り付けてください。\r\n`
          + `https://inquiry.dr-ubie.com/doctors/inquiry-results\r\n`
          + `ログインID：ubie@fastdoctor.jp\r\n`
          + `ログインPASS：SVに確認\r\n`
          + `患者ID：${this.ubie_inquiry_token}`;
      }

      return symptomDesc;
    },
    /**
     * ダミーデータ入力
     */
    setDummyDataContact(){
      this.birth_y = '';
      this.birth_m = '';
      this.birth_d = '';
      this.gender = '';
      this.address1 = '';
      this.email = null;
    },
    setDummyDataCreditCard() {
      this.pref_name = '';
      this.city_name = '';
      this.address1 = '';
      this.address2 = '';
      this.gender = '';
      this.birth_y = '';
      this.birth_m = '';
      this.birth_d = '';
      this.email = null;
    },
    setDummyDataNp() {
      this.gender = '';
      this.birth_y = '';
      this.birth_m = '';
      this.birth_d = '';
      this.email = null;
    },
    setDummyDataOncall() {
      this.pref_name = '';
      this.city_name = '';
      this.address1 = '';
      this.address2 = '';
      this.gender = '';
      this.birth_y = '';
      this.birth_m = '';
      this.birth_d = '';
      this.email = null;
      this.symptom_detail =
        '★連携医療機関からの往診委託問い合わせ★' + '\r\n' +
        '医療機関名または施設名：' + this.oncall_shisetsu + '\r\n' +
        '担当医師名：' + this.oncall_ishi + '\r\n' +
        '症状・詳細：' + this.symptom_detail;
    },
    /**
     * 入力内容をAPIへ送信
     */
    sendApi() {
      // ===================================
      // ダミーデータ入力処理
      // ページによって入力項目を排除しておりバックエンドの仕様上足りないため、強引にダミーデータを入れて送信させるため
      // ===================================
      // クレジットカードのときはダミーデータ入力
      if (this.payment === 'クレジットカード') {
        this.setDummyDataCreditCard();
      }
      // コンビニ支払い（NP後払い）のときはダミーデータ入力
      if (this.payment === 'コンビニ支払い（NP後払い）') {
        this.setDummyDataNp();
      }
      // oncallページ
      if (this.page === 'oncall') {
        this.setDummyDataOncall();
      }
      if (this.page === 'contact') {
        this.setDummyDataContact();
      }
      // ===================================
      // ダミーデータ入力処理ここまで
      // ===================================

      // genderの文字列をAPIに送信する形式に変換
      if (this.gender !== '') {
        var gender = (this.gender === '男性') ? 'male' : 'female';
      } else {
        var gender = '';
      }

      // 誕生日をマージ
      var birth = this.birth_y + "-" + this.birth_m + "-" + this.birth_d;

      // 症状詳細をマージ
      var symptomDesc = this.mergeSymptomDesc();

      // オンライン診療の場合は追加でリクエスト
      var outpatient = null;
      if (this.page === 'online') {
        outpatient = "online_examination";
      }

      var request_reply_method = (this.request_reply_method === 'sms') ? '' : this.request_reply_method;

      // API送信データの生成
      var sendData =
        {
          "patient": {
            "first_name": '',
            "last_name": '',
            "first_kana_name": this.name_mei,
            "last_kana_name": this.name_sei,
            "birthday": birth,
            "gender":  gender,
            "tel": this.tel,
            "email": this.email,
            "address": {
            "zip_code": "",
            "prefecture_name": this.pref_name,
            "city_name": this.city_name,
            "address1": this.address1,
            "address2": this.address2
            }
          },
          "reception": {
            "reservation_method": "fast_doctor_site",
            "desired_time": "",
            "symptom_description": symptomDesc,
            "outpatient": outpatient,
            "request_reply_method": request_reply_method,
          }
        };
      $.ajax({
        url: this.getEndPointUrl(),
        type: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        scriptCharset: 'utf-8',
        data: JSON.stringify(sendData),
      })
      // 成功時
      .done((result) => {
        if (result.reception.state === 'cancelled') {
          this.seen = 'cancelled';
          return;
        }

        if (result.reception.cancel_reason_type === 'unavailable_area') {
          this.seen = 'unavailableArea';
          return;
        }

        console.log('送信成功');

        // オンライン診療の場合は完了画面表示、それ以外は完了画面へリダイレクト
        if (this.page === 'online') {
          this.conversionEventTracking(this.page, 'click', 'complete');
          this.user_site_url = this.endpoint.base_url + 'user_site/medical_examinations/' + result.reception.home_visit_token;
          this.seen = 'result';
        } else if (this.page === 'oncall') {
          this.conversionEventTracking(this.page, 'click', 'complete');
          this.seen = 'result';
        } else {
          if(this.ubie_inquiry_token) {
            location.href = `/contact-complete/?inquiryToken=${this.ubie_inquiry_token}&fast_doctor_user_id=${result.reception.code}`;
            return
          }
          location.href = '/contact-complete/';
        }
      })
      // 失敗時
      .fail((result) => {
        console.log('送信失敗');
        this.seen = 'error';
      })
      // 成功・失敗両方呼ばれる
      .always((result) => {
      });
    },
    conversionEventTracking(category, action, str){
      window.FD.conversionEventTracking(category, action, str);
    },
    // ==========================
    // 以下郵便番号チェック用
    // ==========================
    change(){
      this.status = ''
      this.addr = {}
      if (this.sanitize_zip_code ==! '') return
      new YubinBango.Core(this.sanitize_zip_code, (addr) => {
        // console.log(addr)
        this.addr = addr;
      })

      if(this.is_changed) return
      this.conversionEventTracking('night-zip', 'input', 'zip_code')
      this.is_changed = true;
    },
    async checkSupportArea(){
      if (this.buttonDisabled) return
      if (!this.addr.region) {console.error("region not found"); return}
      if (!this.addr.locality) {console.error("locality not found"); return}
      if (!this.addr.street) {console.error("street not found"); return}
      this.conversionEventTracking('night-zip', 'click', 'search')
      this.is_fetch = true;
      const response = await axios({
        method: "POST",
        url: this.endpoint.area,
        data: {
          address: {
            prefecture_name: this.addr.region,
            city_name: this.addr.locality,
            address1: this.addr.street,
          }
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer dummyToken"
        }
        })
        .catch((e) => {
          console.error('error', e);
          this.status = 'error';
        });
      this.is_fetch = false;
      this.$refs.input_postal_code.blur();
      if (!response || !response.data) {
        console.error('response.data is not found');
        this.status = 'error';
      }
      if (response.data.available === true) {
        this.status = 'match';
        this.pref_name = this.addr.region;
        this.address1 = this.addr.street;
        this.setCityList();
        this.city_name = this.addr.locality;
        return
      }
      this.status = 'noMatch';
      this.pref_name = '';
      this.address1 = '';
      this.city_name = '';
      return
    },
    toOushin(event){
      this.conversionEventTracking(this.page, 'click', 'toOushin')
      if (!window.pagescroll) { console.error('not found pagescroll'); return; }
      const href = event.target.getAttribute('href')
      event.preventDefault();
      window.pagescroll.scrollTo(href, -160)
    },
    async updateSharedState() {
      if (document.visibilityState !== 'visible') return;
      this.sharedState = storeOnlineStatus.state;
    }

  }
});
